import { useEffect, useState } from "react";
import { Select } from "antd";
import { Presentation } from "lucide-react";
import useApiMethods from "../../../lib/useApiMethods";
import { DEMO_PRESENTER_URL } from "../../../constants/api";

/**
 * "Demo by" on the lead status form, for a move into Demo Fixed / Demo Done.
 *
 * The company sets one default presenter (Settings → Email Templates → Demo
 * feedback request). Unless it lets reps choose, this is just a line saying
 * who the demo is credited to; the server fills it in either way, so `value`
 * stays null unless the rep picks someone else.
 */
export default function DemoPresenterField({ value, onChange }) {
    const { fetch } = useApiMethods();
    const [opts, setOpts] = useState(null);

    useEffect(() => {
        let live = true;
        fetch(DEMO_PRESENTER_URL).then(res => {
            if (live && res?.status === "success") setOpts(res.data);
        });
        return () => { live = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!opts) return null;

    if (!opts.can_choose) {
        return (
            <p className="flex items-center gap-1.5 text-xs text-gray-600 dark:text-gray-300 mb-3">
                <Presentation className="h-3.5 w-3.5 text-gray-400" aria-hidden="true" />
                Demo by <b>{opts.default_presenter_name}</b>
            </p>
        );
    }

    return (
        <div className="mb-3">
            <label className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5 block">
                Demo by
            </label>
            <Select
                className="w-full" size="large" showSearch optionFilterProp="label" aria-label="Demo by"
                value={value ?? opts.default_presenter_id ?? undefined}
                placeholder="Who takes the demo?"
                options={opts.presenters.map(p => ({ value: p.id, label: p.name }))}
                onChange={(v) => onChange(v ?? null)}
            />
        </div>
    );
}
